/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Environments {
    Localhost = 10,
    Development = 20,
    Staging = 30,
    PreProduction = 40,
    Production = 50,
}
